import { Link } from 'react-router-dom';

export default function SplitCTA() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px] md:min-h-[560px]">
      <div className="relative w-full lg:w-1/2 min-h-[320px] md:min-h-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20side%20angle%20of%20a%20curated%20fashion%20rack%20with%20linen%20shirts%20cashmere%20sweaters%20and%20tailored%20trousers%20hanging%20on%20minimalist%20wooden%20hangers%20against%20warm%20plaster%20wall%2C%20soft%20golden%20afternoon%20sunlight%20casting%20elongated%20shadows%2C%20small%20woven%20basket%20with%20dried%20flowers%20on%20rustic%20wooden%20floor%2C%20sophisticated%20boutique%20aesthetic%20with%20warm%20neutral%20and%20earthy%20tones&width=1200&height=900&seq=split-cta-v3&orientation=portrait"
          alt="CSSBuy spreadsheet curated fashion"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-50/40"></div>
        <div className="absolute top-8 left-8">
          <span className="text-xs font-semibold text-background-50/80 uppercase tracking-wider bg-foreground-900/30 backdrop-blur-sm px-3 py-1 rounded-full font-label">
            Curated Picks
          </span>
        </div>
        <div className="absolute bottom-10 left-8 right-8">
          <h3 className="font-heading text-2xl md:text-4xl lg:text-5xl font-extrabold text-background-50 leading-[1.1] tracking-tight">
            Find Your<br />Perfect<br />Spreadsheet
          </h3>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-10 py-14 md:py-0">
        <div className="max-w-md text-center lg:text-left">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight tracking-tight mb-4">
            Ready to Start<br />Shopping Smarter?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 font-body max-w-[400px] mx-auto lg:mx-0">
            Access the latest CSSBuy spreadsheet with verified sellers, updated weekly. Save time, avoid scams, and discover the best products from trusted proxy shopping agents.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer font-label"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
            <Link
              to="/article/best-cssbuy-spreadsheet-guide-2026"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-700 text-sm font-medium rounded-full hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer font-label border border-background-200/70"
            >
              Read Our Guide
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}